/**
 * This is the list contains the way we make AI calls in this application
 *
 */
import fetchWithToken from "@utils/tokenUtils";
import { IUserLogin } from "../types/user.data";
import {
  AuthResponse,
  IAuth,
  ILanguages,
  langaugesApiResponse,
} from "src/types";
import { API_URL } from "../config";

export const LoginService = async (userData: IUserLogin): Promise<IAuth> => {
  try {
    const response = await fetch(`https://core.pluritongues.com/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      throw new Error("Invalid Login Credentials Provided.");
    }

    const Authresponse = await response.json();
    return Authresponse;
  } catch (error) {
    const msg =
      error instanceof Error
        ? error.message
        : "Apologies, something went wrong. Please try again later.";
    throw new Error(msg);
  }
};

export const getRequest = async <T>(url: string): Promise<T> => {
  const response = await fetchWithToken(url);

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "An error occured");
  }
  return response.json();
};

export const postRequest = async <T>(
  url: string,
  body: any,

  method: "POST" | "PATCH" = "POST"
): Promise<T> => {
  const response = await fetchWithToken(url, {
    method: method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "An error occurred");
  }

  return response.json();
};

export const fileUpload = async (url: string, formData: any) => {
  const response = await fetchWithToken(url, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Upload failed");
  }
};

export const updateRequest = async <T>(
  url: string,
  body: any,
  headers: Record<string, string> = { "Content-Type": "application/json" }
): Promise<T> => {
  const response = await fetchWithToken(url, {
    method: "PATCH",
    headers,
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "An error occurred");
  }

  return response.json();
};

export const fetchAllLanguages = async (): Promise<langaugesApiResponse> => {
  const languages = await getRequest<langaugesApiResponse>(
    `https://core.pluritongues.com/languages/supported-languages`
  );
  return languages;
};
